import React from 'react'

const DEFAULT_ITEMS = [
  'For private meetings, only the meeting owner will receive email notifications.',
  'For shared meetings, notifications will be sent exclusively to the members it has been shared with, ensuring that only the relevant individuals are kept informed.',
]

interface WhoGetsNotifiedHeaderProps {
  items?: string[]
}

export const WhoGetsNotifiedHeader = ({ items = DEFAULT_ITEMS }: WhoGetsNotifiedHeaderProps) => (
  <div className='d-flex flex-column'>
    <div className='paragraph-medium medium'>Who gets notified</div>
    <ul className='paragraph-small zocks-text-gray-600 ps-3 mb-0'>
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  </div>
)
